import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { getSavePrequalRoute } from "@api-routes/eirSalesFacade";
import { IEirSalesSavePrequalPayload } from "@modules/eirSalesFacade/interfaces/payloads/IEirSalesSavePrequalPayload";
import { mapEirSalesPrequal } from "@modules/eirSalesFacade/mappers/mapEirSalesPrequal";
import { IEirSalesPrequal } from "@modules/eirSalesFacade/interfaces/models/IEirSalesPrequal";

export const postSavePrequal = (
    prospectReference: string,
    payload: IEirSalesSavePrequalPayload,
    options: IFetchOptions = {}
) =>
    fetcher<IEirSalesPrequal>(getSavePrequalRoute(prospectReference), {
        method: "POST",
        body: payload,
        mapper: mapEirSalesPrequal,
        ...options,
    });
